import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetPagoUnicoCATAByID = {
  status: number | null;
  statusText: string | null;
};

const useGetPagoUnicoCATAByID = () => {
  const [loadingGetPagoUnicoCATAByID, setLoadingPagoUnicoCATAByID] = useState(false);
  const [successGetPagoUnicoCATAByID, setSuccessPagoUnicoCATAByID] = useState(false);
  const [errorGetPagoUnicoCATAByID, setErrorPagoUnicoCATAByID] = useState<any>(null);
  const [dataGetPagoUnicoCATAByID, setDataPagoUnicoCATA] = useState<any>(null);

  const [statusGetPagoUnicoCATAByID, setStatusGetPagoUnicoCATAByID] =
    useState<StatusGetPagoUnicoCATAByID>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  // GET
  const getPagoUnicoCATAByID = async (
    userId: string,
    prestacionId: string,
    id: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingPagoUnicoCATAByID(true);
    setSuccessPagoUnicoCATAByID(false);
    setErrorPagoUnicoCATAByID(null);

    try {
      const res = await apiRecord.getSolicitudPagoUnicoByID(userId, prestacionId, id);

      setStatusGetPagoUnicoCATAByID({
        status: res.status,
        statusText: res.statusText
      });

      setSuccessPagoUnicoCATAByID(true);
      setDataPagoUnicoCATA(res.data);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;

    } catch (err: any) {

      setStatusGetPagoUnicoCATAByID({
        status: err?.response?.status || 500,
        statusText: err?.response?.statusText || "Error"
      });

      setErrorGetPagoUnicoCATAByID(err);
      console.error("Error en getPagoUnicoCATAByID:", err);

      throw err;

    } finally {
      setLoadingPagoUnicoCATAByID(false);
    }
  };

  return {
    getPagoUnicoCATAByID,
    loadingGetPagoUnicoCATAByID,
    successGetPagoUnicoCATAByID,
    errorGetPagoUnicoCATAByID,
    dataGetPagoUnicoCATAByID,
    statusGetPagoUnicoCATAByID
  };
};

export default useGetPagoUnicoCATAByID;
